import React, { useEffect, useState } from "react";
import { ArcElement, Chart as ChartJS } from "chart.js";
import LineChart from "@/components/Widgets/LineChart";
ChartJS.register(ArcElement);

import "./ProgressBarChart.css";

const NutriLineChart = ({ title, data }) => {
  if (!data) return null;

  return (
    <LineChart
      data={data}
      customOptions={{
        responsive: true,
        maintainAspectRatio: false,
        pointRadius: 4,
        layout: {
          padding: 18,
        },
        plugins: {
          legend: {
            display: false,
            position: "bottom",
            labels: { usePointStyle: true },
          },
          title: {
            display: true,
            text: title,
            color: "black",
            font: {
              size: 16,
            },
          },
          datalabels: {
            anchor: "end",
            align: "end",
            offset: -5,
            color: "#fff",
            borderColor: "#000",
            textStrokeColor: "black", // <-- added this
            textStrokeWidth: 3, // <-- added this,
            font: {
              size: 10,
            },
          },
        },
      }}
    />
  );
};

export default NutriLineChart;
